import Vue from 'vue'
//import Vuetify from 'vuetify'
import './plugins/vuetify'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
//import Vuetify from './plugins/vuetify';
import vuetify from '@/plugins/vuetify' // path to vuetify export
import store from './store';
import VueRouter from 'vue-router'
import routes from './routes';
import AddToCalendar from 'vue-add-to-calendar';

Vue.use(VueAxios, axios)
Vue.use(vuetify)
Vue.use(VueRouter)

AddToCalendar.version = '1.0.4';

AddToCalendar.install = (Vue) => {
  Vue.component('add-to-calendar', AddToCalendar);
};
if (typeof window !== 'undefined') {
  window.AddToCalendar = AddToCalendar;
}

export default AddToCalendar;

const router = new VueRouter({mode: 'history', routes});

Vue.config.productionTip = false;

new Vue({
  name:"main",
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

